import { render, staticRenderFns } from "./ControlPanelBlock.vue?vue&type=template&id=64e4687a&scoped=true&"
import script from "./ControlPanelBlock.vue?vue&type=script&lang=js&"
export * from "./ControlPanelBlock.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelBlock.vue?vue&type=style&index=0&id=64e4687a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4687a",
  null
  
)

export default component.exports